import React, { useState } from 'react';
import ListView from '../../components/views/listView';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { HOME } from '../../../routes/paths';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import DatePickerField from '../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { ExportTypificationMessages } from '../../../shared/messages/exportTypificationMessages';
import { SwalCustomClass } from '../../components/general/toastSwals/swalCustomClass';
import { IconWrapper } from '../../components/general/stylesComponents/stylesComponents';
import { b64toBlob } from '../../../shared/utils/files';

const ExportTypifications = () => {
    const navigate = useNavigate();
    const [startTime, setStartTime] = useState<any>(null);
    const { TITLE, MESSAGE_OK, MESSAGE_ERROR } = ExportTypificationMessages;
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            startTime: null,
            endTime: null,
        },
        validationSchema: Yup.object({
            startTime: Yup.string().required('La fecha inicial es obligatoria'),
            endTime: Yup.string()
                .nullable()
                .when(['startTime'], {
                    is: (startTime: any) => Boolean(startTime !== null),
                    then: (schema) =>
                        schema.required('La fecha final es obligatoria'),
                }),
        }),
        onSubmit: async (exportActivityTimes: any) => {
            exportActivityTimes.endTime = dayjs(
                exportActivityTimes.endTime
            ).endOf('day');
            setLoading(true);
            const body: any = {};
            if (body.items !== undefined) {
                const blob = b64toBlob(
                    body.items,
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                );
                const blobUrl = URL.createObjectURL(blob);
                window.location = blobUrl as any;
                SwalCustomClass.fire({
                    text: MESSAGE_OK,
                    icon: 'success',
                    iconColor: '#1d1d1d',
                });
            } else {
                SwalCustomClass.fire({
                    text: MESSAGE_ERROR,
                    icon: 'error',
                    iconColor: '#1d1d1d',
                });
            }
            setLoading(false);
        },
    });

    const validateStartTime = (value: any) => {
        setStartTime(value);
        formik.values.startTime = value;
    };

    return (
        <>
            <ListView
                title={TITLE}
                titleButtonAdd={'Descargar'}
                onClickAdd={formik.handleSubmit}
                startIconButtonAdd={
                    <FileDownloadIcon sx={{ color: 'primary.contrastText' }} />
                }
                onClickBack={() => navigate(HOME)}
                disableDataGrid={true}
            />
            {loading ? (
                <IconWrapper>
                    <CircularProgress size={70} thickness={2} />
                </IconWrapper>
            ) : (
                <form className="form">
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        sx={{ minWidth: 300 }}
                    >
                        <Grid item xs={12} sm={6}>
                            <DatePickerField
                                label="Fecha inicio"
                                name="startTime"
                                size="small"
                                required={true}
                                maxDate={dayjs()}
                                touched={formik.touched.startTime}
                                errors={formik.errors.startTime?.toString()}
                                value={formik.values.startTime}
                                onChange={(value) => validateStartTime(value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DatePickerField
                                label="Fecha fin"
                                name="endTime"
                                size="small"
                                required={Boolean(startTime)}
                                minDate={dayjs(startTime)}
                                maxDate={dayjs()}
                                disabled={!startTime}
                                touched={formik.touched.endTime}
                                errors={formik.errors.endTime?.toString()}
                                value={formik.values.endTime}
                                onChange={(value) =>
                                    formik.setFieldValue('endTime', value, true)
                                }
                            />
                        </Grid>
                    </Grid>
                </form>
            )}
        </>
    );
};

export default ExportTypifications;
